// src/appId.ts
console.log("Loading appId.ts");

function uuidv4(): string {
  const c: Crypto | undefined = globalThis.crypto as Crypto | undefined;

  // Prefer the native UUID if available (widely supported in modern browsers).
  if (c?.randomUUID) return c.randomUUID();

  // Cryptographically-strong fallback.
  if (c?.getRandomValues) {
    const bytes = c.getRandomValues(new Uint8Array(16));
    // RFC 4122 version/variant bits
    bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
    bytes[8] = (bytes[8] & 0x3f) | 0x80; // variant 10
    const hex = Array.from(bytes, b => b.toString(16).padStart(2, "0")).join("");
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  }

  // Math.random fallback (not crypto-strong).
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, ch => {
    const r = (Math.random() * 16) | 0;
    const v = ch === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function getOrCreateBrowserId(storage: Storage = localStorage): string {
  try {
    let appId = storage.getItem("appId");
    if (!appId) {
      appId = uuidv4();
      storage.setItem("appId", appId);
      console.log("Generated new browser ID:", appId);
    } else {
      console.log("Existing browser ID:", appId);
    }
    return appId;
  } catch (err) {
    // localStorage can be blocked/disabled; fall back to an ephemeral ID.
    const id = uuidv4();
    console.warn("Storage unavailable; using ephemeral ID", err);
    return id;
  }
}

// NOTE: This is a *string value*, not a function—kept to match your original export.
export const getAppId: string = getOrCreateBrowserId();
